"use client";

import React, { useState } from "react";
import ShowcaseAuthModal from "@/components/ShowcaseAuthModal";
import { EventConfig } from "@/hooks/useAddShowcase";
import { ResponseData, TProductInfo, TSamplesCheckResponse } from "@/typings";
import SkuModal from "@/components/SkuModal";
import PlatformCheckSampleModal from "@/components/PlatformCheckSampleModal";
import ShowcaseSampleGuideModal from "@/components/ShowcaseSampleGuideModal";

export interface AuthorizeContextProps {
  $showcaseAuthVisible?: (v: boolean) => void;
  $eventConfig?: (eventConfig?: EventConfig) => void;
  $product?: (product?: TProductInfo) => void;
  skuVisible?: boolean;
  $skuVisible?: (v: boolean) => void;
  isAddedShowcase?: boolean;
  $isAddedShowcase?: (v: boolean) => void;
  $showcaseSampleGuideVisible?: (v: boolean) => void;
}

const AuthorizeContext = React.createContext<AuthorizeContextProps>({});

function AuthorizeProvider({ children }: { children: React.ReactNode }) {
  const [showcaseAuthVisible, $showcaseAuthVisible] = useState<boolean>(false);
  const [skuVisible, $skuVisible] = useState<boolean>(false);
  const [eventConfig, $eventConfig] = useState<EventConfig>();
  const [product, $product] = useState<TProductInfo>();
  const [sampleVisible, $sampleVisible] = useState<boolean>();
  const [sampleCheck, $sampleCheck] =
    useState<ResponseData<TSamplesCheckResponse>>();
  const [showcaseSampleGuideVisible, $showcaseSampleGuideVisible] =
    useState<boolean>();

  return (
    <AuthorizeContext.Provider
      value={{
        $showcaseAuthVisible,
        $eventConfig,
        $product,
        skuVisible,
        $skuVisible,
        $showcaseSampleGuideVisible,
      }}
    >
      {showcaseSampleGuideVisible && product && (
        <ShowcaseSampleGuideModal
          visible={showcaseSampleGuideVisible}
          onCancel={() => {
            $showcaseSampleGuideVisible(false);
          }}
          onOk={() => {
            $showcaseSampleGuideVisible(false);
            $skuVisible(true);
          }}
          eventConfig={eventConfig}
          product={product}
        />
      )}
      {sampleVisible && sampleCheck && (
        <PlatformCheckSampleModal
          visible={sampleVisible}
          onCancel={() => {
            $sampleVisible(false);
            $sampleCheck(undefined);
          }}
          sampleCheck={sampleCheck}
        />
      )}
      {showcaseAuthVisible && product && (
        <ShowcaseAuthModal
          visible={showcaseAuthVisible}
          onCancel={() => $showcaseAuthVisible(false)}
          eventConfig={eventConfig}
          product={product}
        />
      )}
      {skuVisible && product && (
        <SkuModal
          skuVisible={skuVisible}
          onClose={() => $skuVisible(false)}
          onOk={(v, _sampleCheck) => {
            $skuVisible(v);
            if (_sampleCheck) {
              $sampleVisible(true);
              $sampleCheck(_sampleCheck);
            }
          }}
          productData={product}
          eventConfig={eventConfig}
        />
      )}
      {children}
    </AuthorizeContext.Provider>
  );
}

export { AuthorizeContext, AuthorizeProvider };
